import { RxConversationAPI, PagesAPI, checkStatus, json } from '@drifthq/dapper'

export const api = {
  updateStatus(id, status) {
    return RxConversationAPI
      .patch(`/playbooks/${id}/${status}`)
      .checkStatus()
      .retryWithBackoff()
      .pluck('response')
  },
  createNewsletterPlaybook(options) {
    return RxConversationAPI
      .post(`/playbooks/onboarding_newsletter`, options)
      .checkStatus()
      .retryWithBackoff()
      .pluck('response')
  },
  createDemoRequestPlaybook(options) {
    return RxConversationAPI
      .post(`/playbooks/onboarding_demo_request`, options)
      .checkStatus()
      .retryWithBackoff()
      .pluck('response')
  },
  saveLandingPageSettings(id, settings) {
    return PagesAPI
      .put(`/pages/${id}`, settings)
      .then(checkStatus)
      .then(json)
  },
  fetchLandingPageSettings(id) {
    return PagesAPI
      .get(`/pages/${id}`)
      .then(checkStatus)
      .then(json)
  },
   fetchLandingPageSubdomain() {
    return PagesAPI
      .get('/subdomain')
      .then(checkStatus)
      .then(json)
  },
   fetchLandingPageCname() {
    return PagesAPI
      .get('/cnames')
      .then(checkStatus)
      .then(json)
  },
  createWelcomePlaybooks(onlineText, offlineText) {
    return RxConversationAPI
      .post('/playbooks/welcome_messages?enable=true', { onlineText, offlineText })
      .checkStatus()
      .retryWithBackoff()
  },
  updateLandingPageSubdomain (subdomain) {
    return PagesAPI
      .patch('/subdomain', { subdomain })
      .then(checkStatus)
      .then(json)
  }
}



// WEBPACK FOOTER //
// ./src/modules/playbook/api.js